export default [
	// 虚拟养老院--调用1+x页面
	{
		path: 'other',
		component: () => import('../../views/platform/other/index'),
		children: [{
			path: '1_x_oldAge_vnh',
			component: () => import('../../views/platform/webgl/software_template/1_x_oldAge_vnh')
		},{
			path: 'VirtualNH_jobPost',
			component: () => import('../../sys/softwareManage/virtualNH/VirtualNH_jobPost')
		},
		{
			path: 'VirtualNH_jobPost_user',
			component: () => import('../../sys/softwareManage/virtualNH/VirtualNH_jobPost_user')
		},{
			path: 'VirtualNH_knowledge_graph',
			component: () => import('../../sys/softwareManage/virtualNH/VirtualNH_knowledge_graph')
		},
		{
			path: 'nlpg_tinetti',
			component: () => import('../../views/platform/other/linxia/tinetti')
		},{
			path: 'nlpg_tunyan',
			component: () => import('../../views/platform/other/linxia/tunyan')
		}]
	}
]